import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BulkUploadFile from "../../components/BulkUploadFile";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Drivers will be opted out of the Gigs from next day onwards.",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const GigsBulkOptOut = ({ getGigsBulkOptOutUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="driverSlotsCancellationFeeExemption"
      uploadUrl="/driver-shift/slot/bulk-driver-gigs-opt-out/ack"
      sampleURL="/sample/bulk_driver_gigs_opt_out.csv"
      id="driverSlotsCancellationFeeExemptionModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Gigs Opt Out"
      getUploadUrl={getGigsBulkOptOutUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getGigsBulkOptOutUrl: bindActionCreators(
      SlotsPropertiesActions.getGigsBulkOptOutUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(GigsBulkOptOut);
